<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="process-stages-title" :field="fields?.title" tag="h2" />
      <div class="process-stages-content">
        <div class="process-stages-list" v-if="fields?.list?.length > 0">
          <div class="process-stages-list-line"></div>
          <div class="process-stages-list-item" v-for="item in fields?.list" :key="item?.id">
            <JssRichText
              class="process-stages-list-item-desc"
              :field="item?.fields?.desc"
              :style="{ backgroundColor: item?.fields?.descBgColor?.value }"
            />
            <div class="process-stages-list-item-icon">
              <AdaptiveImage
                :field="item?.fields?.image"
                :isBackground="false"
                :lazy-load="false"
                :enableScrollDetection="false"
                :show="true"
              />
            </div>
          </div>
        </div>
        <div class="process-stages-card" v-if="fields?.cardList?.length > 0">
          <div class="process-stages-card-item" v-for="item in fields?.cardList" :key="item?.id">
            <JssRichText class="process-stages-card-item-title" :field="item?.fields?.text" />
          </div>
        </div>
        <div class="process-stages-step" v-if="fields?.stepList?.length > 0">
          <div class="process-stages-step-item" v-for="item in fields?.stepList" :key="item?.id">
            <div class="process-stages-step-item-title">
              <JssRichText :field="item?.fields?.stepTitle" />
            </div>
            <JssRichText
              class="process-stages-step-item-desc"
              :field="item?.fields?.stepSubtitle"
            />
          </div>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'ProcessStages',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'process-stages'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.process-stages {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-content {
    width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-list {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 40px;
    position: relative;

    &-line {
      position: absolute;
      top: 118px;
      left: 60px;
      width: 1000px;
      height: 2px;
      background: linear-gradient(90deg, #d4d4d4, #a8a8a8);
    }

    &-item {
      flex: 1;
      min-width: 150px;

      &-desc {
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;
        color: $grey-black;
        padding: 0 20px;
        height: 64px;
        border-radius: 4px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-icon {
        width: 100%;
        height: 62px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 24px;

        .e-background-image {
          width: 62px;
          height: 62px;
        }
      }
    }
  }

  &-card {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 24px;
    min-width: 1122px;

    &-item {
      background: rgba(#c7d3c7, 0.3);
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 54px;

      &:nth-child(1) {
        flex: 1;
      }

      &:nth-child(2) {
        flex: 1;
      }

      &:nth-child(3) {
        flex: 2;
      }

      &:nth-child(4) {
        flex: 1;
      }

      &:nth-child(5) {
        flex: 2;
      }
    }
  }

  &-step {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    gap: 10px;
    min-width: 1122px;

    &-item {
      flex: 1;
      position: relative;

      &:not(:first-child) {
        margin-left: -3px;

        .process-stages-step-item-title {
          border-radius: 0;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 0;
            border-top: 30px solid transparent;
            border-bottom: 30px solid transparent;
            border-left: 30px solid $white;
          }
        }
      }

      &:last-child {
        .process-stages-step-item-title {
          border-radius: 8px;

          &::after {
            display: none;
          }
        }
      }

      &-title {
        font-size: 16px;
        line-height: 1.4;
        font-weight: 700;
        color: $grey-black;
        background: #efeadf;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-radius: 8px 0 0 8px;

        &::after {
          content: '';
          position: absolute;
          right: -30px;
          top: 0;
          width: 0;
          height: 0;
          border-top: 30px solid transparent;
          border-bottom: 30px solid transparent;
          border-left: 30px solid #efeadf;
          z-index: 1;
        }
      }

      &-desc {
        font-size: 16px;
        color: $grey-black;
        line-height: 1.4;
        margin: 24px 6px 0;
        text-align: center;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-list {
      &-line {
        left: 0;
        width: 100%;
      }
    }
  }
}
</style>
